/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import "primeicons/primeicons.css";
import PropTypes from "prop-types";
import "../NavBar/Navbar.scss";
import reseau_pro_gris from "assets/reseau_pro_gris.png";
import logo_unif from "assets/logo_unif.webp";
import { connect } from "react-redux";
import { Button } from "primereact/button";
import ModalConnexion from "Components/Modal/ModalConnexion/ModalConnexion";
import { updateAuth } from "Redux/Actions/authActions";
import Modal from "Components/Modal/Modal";
import { updateMenu } from "Redux/Actions/menuActions";
import { SlideMenu } from "primereact/slidemenu";
import { FaRegUserCircle } from "react-icons/fa";
import NavBarMobile from "./NavBarMobile/NavBarMobile";
import MenuDepliant from "./MenuDepliant/MenuDepliant";
import settings from "assets/settings.png";
import settingsBlanc from "assets/settingsBlanc.png";
import {
  findItemInEditManagementVisibility,
  findManagementContentByLabel,
} from "Services/functions";
import neutralUser from "assets/neutralUser.png";

/**
 * Construit la barre de navigation
 * Fait appel à NavBarMobile pour les menus mobile
 * et MenuDépliant pour les menus dépliant de la navigation desktop
 */
const NavBar = (props) => {
  const [navBarOpen, setNavBarOpen] = useState(false);
  const menu = useRef(null);
  const [openAnnuaireInterface, setOpenAnnuaireInterface] = useState(false);
  const [openEvenementInterface, setOpenEvenementInterface] = useState(false);
  const [openActuInterface, setOpenActuInterface] = useState(false);
  const [openOffreInterface, setOpenOffreInterface] = useState(false);
  const [openGroupeInterface, setOpenGroupeInterface] = useState(false);
  const [openParametreInterface, setOpenParametreInterface] = useState(false);
  const [visibleModalAnnuaire, setVisibleModalAnnuaire] = useState(false);
  const [openCVThequeInterface, setOpenCVThequeInterface] = useState(false);
  const menuNotConnected = useRef(null);
  const [visibleModal, setVisibleModal] = useState(false);
  const location = useLocation();
  const API_LINK = process.env.REACT_APP_BASE_URL_API.split("/api")[0];
  const itemsAnnuaireVisible = [];
  props.items?.itemsAnnuaire?.map((itemAnnuaire) => {
    if (
      findItemInEditManagementVisibility(
        itemAnnuaire?.data,
        props.admin.editManagementBoolean
      )
    ) {
      itemsAnnuaireVisible.push(itemAnnuaire);
    }
  });
  let itemsNotConnected = [
    {
      label: "Accueil",
      command: () => (window.location.href = "/"),
    },

    { separator: true },
    {
      label: "Actualités",
      command: () => (window.location.href = "/actualites"),
    },
    { separator: true },
    {
      label: "Événements",
      command: () => (window.location.href = "/evenements"),
    },
    { separator: true },
    {
      label: "Nos universités",
      command: () => (window.location.href = "/universites"),
    },
    { separator: true },
    {
      label: "Espace recruteurs",
      command: () => (window.location.href = "/espace-recruteurs"),
    },
    { separator: true },
    {
      label: "Connexion",
      command: () => {
        setVisibleModal(!visibleModal);
      },
    },
    { separator: true },
    {
      image: { logo_unif },
      className: "logoUnif_burger",
    },
  ];

  const isStudent =
    props.auth.isConnected &&
    props.auth.userConnected.userRoles.some((role) =>
      role.roleName.includes("ROLE_ETUDIANT")
    );
  const isAlumni =
    props.auth.isConnected &&
    props.auth.userConnected.userRoles.some(
      (role) => role.roleName == "ROLE_ALUMNI"
    );
  const isPersonnel =
    props.auth.isConnected &&
    props.auth.userConnected.userRoles.some(
      (role) => role.roleName == "ROLE_PERSONNEL_UNIVERSITE"
    );
  return (
    <div>
      {visibleModal && (
        <ModalConnexion
          visibleModal={visibleModal}
          setVisibleModal={setVisibleModal}
        />
      )}
      <nav className="navigation">
        <div className="navigation__hamburger">
          {/* On est connecté */}
          {props.auth.isConnected &&
            props.auth.userConnected &&
            // En tant qu'admin
            (() => {
              switch (true) {
                case props.auth.isAdmin:
                  return (
                    <div>
                      <NavBarMobile
                        menuNotConnected={menuNotConnected}
                        role="admin"
                      />
                      <Button
                        icon="pi pi-bars"
                        onClick={(event) => (
                          menuNotConnected.current.toggle(event),
                          setNavBarOpen(!navBarOpen)
                        )}
                      />
                    </div>
                  );
                // En tant qu'un autre rôle (étudiant, alumni, personnel)
                case isStudent || isAlumni || isPersonnel:
                  return (
                    <div>
                      <NavBarMobile
                        menuNotConnected={menuNotConnected}
                        role={
                          isStudent
                            ? "etudiant"
                            : isAlumni
                            ? "alumni"
                            : isPersonnel && "enseignant"
                        }
                      />
                      <Button
                        icon="pi pi-bars"
                        onClick={(event) =>
                          menuNotConnected.current.toggle(event)
                        }
                      />
                    </div>
                  );
                default:
                  return null;
              }
            })()}

          {/* on n'est pas connecté */}
          {!props.auth.isConnected && (
            <div>
              <SlideMenu
                model={itemsNotConnected}
                viewportHeight={220}
                menuWidth={175}
                popup
                ref={menu}
                style={{ textAlign: "start", left: "0", width: "175px" }}
              />
              <Button
                icon="pi pi-bars"
                onClick={(event) => (
                  menu.current.toggle(event), setNavBarOpen(!navBarOpen)
                )}
              />
            </div>
          )}
        </div>
        {/* logo au milieu du menu burger */}
        {!props.auth.isConnected ? (
          <img
            src={reseau_pro_gris}
            className="brand-name"
            alt="Logo de Réseau Pro"
            title="Logo de Réseau Pro"
          />
        ) : (
          <img
            className="brand-name"
            src={
              API_LINK +
              props.auth.universityConnected.imageTransparentAndWhiteUrl
            }
            alt={"Logo Université " + props.auth.universityConnected.name}
            title={"Logo Université " + props.auth.universityConnected.name}
          />
        )}
        {/* logo utilisateur du menu burger */}
        {props.auth.isConnected ? (
          <Link to="/profil">
            <img
              src={
                props.auth.userConnected.imageUrl
                  ? props.auth.userConnected.imageUrl
                  : neutralUser
              }
              className="img-profil"
              alt="Mon avatar"
              title="Mon avatar"
            />
          </Link>
        ) : (
          <FaRegUserCircle className="img-profil__disconnected" />
        )}

        {/* ----------------------------------------- barre de navigation  */}
        <div className="navigation-menu">
          <ul>
            {/* Barre de navigation hors connexion */}
            {!props.auth.isConnected && (
              <>
                <li>
                  <NavLink
                    to="/"
                    className={
                      useLocation().pathname == "/" ? "activeLink" : ""
                    }
                  >
                    <button className="annuaire__button">
                      {findManagementContentByLabel(
                        "accueilTitle",
                        props.admin.editManagement,
                        props.admin.editManagementNexus,
                        props.auth.universityConnected.id
                      ).content || "Accueil"}
                    </button>
                  </NavLink>
                </li>
                <li>
                  <Link
                    to="/actualites"
                    className={
                      useLocation().pathname == "/actualites"
                        ? "activeLink"
                        : ""
                    }
                  >
                    <button className="annuaire__button">
                      {findManagementContentByLabel(
                        "actusTitle",
                        props.admin.editManagement,
                        props.admin.editManagementNexus,
                        props.auth.universityConnected.id
                      ).content || "Actus"}
                    </button>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/evenements"
                    className={
                      useLocation().pathname == "/evenements"
                        ? "activeLink"
                        : ""
                    }
                  >
                    <button className="annuaire__button">
                      {findManagementContentByLabel(
                        "evenementsTitle",
                        props.admin.editManagement,
                        props.admin.editManagementNexus,
                        props.auth.universityConnected.id
                      ).content || "Événements"}
                    </button>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/universites"
                    className={
                      useLocation().pathname == "/universites"
                        ? "activeLink"
                        : ""
                    }
                  >
                    <button className="annuaire__button">
                      Nos universités
                    </button>
                  </Link>
                </li>
                <li>
                  <Link
                    to="/espace-recruteurs"
                    className={
                      useLocation().pathname == "/espace-recruteurs"
                        ? "activeLink"
                        : ""
                    }
                  >
                    <button className="annuaire__button">
                      Espace recruteurs
                    </button>
                  </Link>
                </li>
              </>
            )}
            {/* Barre de navigation connecté */}
            {props.auth.isConnected && props.auth.userConnected && (
              <>
                <li>
                  <NavLink
                    to="/"
                    className={
                      useLocation().pathname == "/" ? "activeLink" : ""
                    }
                  >
                    <button className="annuaire__button">
                      {findManagementContentByLabel(
                        "accueilTitle",
                        props.admin.editManagement,
                        props.admin.editManagementNexus,
                        props.auth.universityConnected.id
                      ).content || "Accueil"}
                    </button>
                  </NavLink>
                </li>
                <li>
                  <Link
                    to="/actualites"
                    className={
                      useLocation().pathname == "/actualites"
                        ? "activeLink"
                        : ""
                    }
                    onMouseEnter={() => setOpenActuInterface(true)}
                    onMouseLeave={() => setOpenActuInterface(false)}
                  >
                    {/* Affichage du menu actualité en fonction rôles */}
                    {(() => {
                      switch (true) {
                        case props.auth.isAdmin:
                          return (
                            <button
                              className="annuaire__button"
                              onClick={() =>
                                props.handleMenu({
                                  activeItemActuAdmin: 0,
                                })
                              }
                            >
                              {findManagementContentByLabel(
                                "actusTitle",
                                props.admin.editManagement,
                                props.admin.editManagementNexus,
                                props.auth.universityConnected.id
                              ).content || "Actus"}
                              {openActuInterface && (
                                <div className="annuaireInterface">
                                  <MenuDepliant item="actuadmin" />
                                </div>
                              )}
                            </button>
                          );
                        case isStudent && !props.auth.isCreator:
                          return (
                            <button className="annuaire__button">
                              {findManagementContentByLabel(
                                "actusTitle",
                                props.admin.editManagement,
                                props.admin.editManagementNexus,
                                props.auth.universityConnected.id
                              ).content || "Actus"}
                            </button>
                          );
                        case isAlumni || isPersonnel || props.auth.isCreator:
                          return (
                            <button
                              className="annuaire__button"
                              onClick={() => {
                                props.handleMenu({
                                  activeItemActu: 0,
                                });
                              }}
                            >
                              {findManagementContentByLabel(
                                "actusTitle",
                                props.admin.editManagement,
                                props.admin.editManagementNexus,
                                props.auth.universityConnected.id
                              ).content || "Actus"}
                              {openActuInterface && (
                                <div className="annuaireInterface">
                                  <MenuDepliant item="actu" />
                                </div>
                              )}
                            </button>
                          );
                        default:
                          return null;
                      }
                    })()}
                  </Link>
                </li>
                <li>
                  <Link
                    to="/evenements"
                    className={
                      useLocation().pathname == "/evenements"
                        ? "activeLink"
                        : ""
                    }
                    onMouseOver={() => setOpenEvenementInterface(true)}
                    onMouseLeave={() => setOpenEvenementInterface(false)}
                  >
                    {/* Affichage du menu événements en fonction des rôles */}
                    {(() => {
                      switch (true) {
                        case props.auth.isAdmin:
                          return (
                            <button
                              onMouseEnter={() =>
                                setOpenEvenementInterface(true)
                              }
                              onMouseLeave={() =>
                                setOpenEvenementInterface(false)
                              }
                              className="annuaire__button"
                              onClick={() => {
                                props.handleMenu({
                                  activeItemEvenementAdmin: 0,
                                });
                              }}
                            >
                              {findManagementContentByLabel(
                                "evenementsTitle",
                                props.admin.editManagement,
                                props.admin.editManagementNexus,
                                props.auth.universityConnected.id
                              ).content || "Événements"}
                              {openEvenementInterface && (
                                <div
                                  className="annuaireInterface"
                                  onMouseEnter={() =>
                                    setOpenEvenementInterface(true)
                                  }
                                  onMouseLeave={() =>
                                    setOpenEvenementInterface(false)
                                  }
                                >
                                  <MenuDepliant item="eventadmin" />
                                </div>
                              )}
                            </button>
                          );
                        case isStudent:
                          return (
                            <button className="annuaire__button">
                              {findManagementContentByLabel(
                                "evenementsTitle",
                                props.admin.editManagement,
                                props.admin.editManagementNexus,
                                props.auth.universityConnected.id
                              ).content || "Événements"}
                            </button>
                          );
                        case isAlumni || isPersonnel:
                          return (
                            <button
                              className="annuaire__button"
                              onClick={() => {
                                props.handleMenu({
                                  activeItemEvenement: 0,
                                });
                              }}
                            >
                              {findManagementContentByLabel(
                                "evenementsTitle",
                                props.admin.editManagement,
                                props.admin.editManagementNexus,
                                props.auth.universityConnected.id
                              ).content || "Événements"}
                              {openEvenementInterface && (
                                <div className="annuaireInterface">
                                  <MenuDepliant item="event" />
                                </div>
                              )}
                            </button>
                          );
                        default:
                          return null;
                      }
                    })()}
                  </Link>
                </li>
                <li
                  onMouseOver={() => setOpenOffreInterface(true)}
                  onMouseLeave={() => setOpenOffreInterface(false)}
                >
                  <Link
                    to="/offres"
                    className={
                      useLocation().pathname == "/offres" ? "activeLink" : ""
                    }
                  >
                    <button
                      className="annuaire__button"
                      onClick={() => {
                        props.handleMenu({
                          activeItemOffre: 0,
                        });
                      }}
                    >
                      {findManagementContentByLabel(
                        "offresTitle",
                        props.admin.editManagement,
                        props.admin.editManagementNexus,
                        props.auth.universityConnected.id
                      ).content || "Offres"}
                      {openOffreInterface && (
                        <div className="annuaireInterface">
                          <MenuDepliant item="offres" />
                        </div>
                      )}
                    </button>
                  </Link>
                </li>
                {!isStudent && (
                  <li>
                    <Link
                      to={{ pathname: "/cvtheque" }}
                      className={
                        useLocation().pathname == "/cvtheque"
                          ? "activeLink"
                          : ""
                      }
                      onMouseEnter={() => setOpenCVThequeInterface(true)}
                      onMouseLeave={() => setOpenCVThequeInterface(false)}
                    >
                      <button
                        className="annuaire__button"
                        onClick={() => {
                          props.handleMenu({
                            activeItemCVTheque: 0,
                          });
                        }}
                      >
                        Cvthèque
                        {openCVThequeInterface && (
                          <div className="annuaireInterface">
                            <MenuDepliant item="cvtheque" />
                          </div>
                        )}
                      </button>
                    </Link>
                  </li>
                )}
                {props.auth.isAdmin ? (
                  <>
                    <li>
                      <Link
                        to="/groupes"
                        className={
                          useLocation().pathname == "/groupes"
                            ? "activeLink"
                            : ""
                        }
                        onMouseEnter={() => setOpenGroupeInterface(true)}
                        onMouseLeave={() => setOpenGroupeInterface(false)}
                      >
                        <button
                          className="annuaire__button"
                          onClick={() => {
                            props.handleMenu({
                              activeItemGroupesAdmin: 0,
                            });
                          }}
                        >
                          {findManagementContentByLabel(
                            "groupesTitle",
                            props.admin.editManagement,
                            props.admin.editManagementNexus,
                            props.auth.universityConnected.id
                          ).content || "Groupes"}
                          {openGroupeInterface && (
                            <div className="annuaireInterface">
                              <MenuDepliant item="groupeadmin" />
                            </div>
                          )}
                        </button>
                      </Link>
                    </li>
                    {findItemInEditManagementVisibility(
                      "visibleAnnuaire",
                      props.admin.editManagementBoolean
                    ) && (
                      <li>
                        <Link
                          to="/annuaire"
                          className={
                            useLocation().pathname == "/annuaire"
                              ? "activeLink"
                              : ""
                          }
                          onMouseEnter={() => setOpenAnnuaireInterface(true)}
                          onMouseLeave={() => setOpenAnnuaireInterface(false)}
                        >
                          <button
                            className="annuaire__button"
                            onClick={() =>
                              props.handleMenu({
                                activeItemAnnuaire: itemsAnnuaireVisible[0],
                              })
                            }
                          >
                            {findManagementContentByLabel(
                              "annuaireTitle",
                              props.admin.editManagement,
                              props.admin.editManagementNexus,
                              props.auth.universityConnected.id
                            ).content || "Annuaire"}
                            {openAnnuaireInterface && (
                              <div className="annuaireInterface">
                                <MenuDepliant item="annuaire" />
                              </div>
                            )}
                          </button>
                          {visibleModal && (
                            <Modal
                              visible={visibleModalAnnuaire}
                              setVisible={setVisibleModalAnnuaire}
                              header="Se connecter"
                            >
                              <form action="/action_page.php">
                                <label htmlFor="fname">First name:</label>
                                <input
                                  type="text"
                                  id="fname"
                                  name="fname"
                                  value="John"
                                />
                                <label htmlFor="lname">Last name:</label>
                                <input
                                  type="text"
                                  id="lname"
                                  name="lname"
                                  value="Doe"
                                />
                                <input type="submit" value="Submit" />
                              </form>
                            </Modal>
                          )}
                        </Link>
                      </li>
                    )}

                    <li>
                      <Link to={{ pathname: "/parametrage" }}>
                        <button
                          onMouseEnter={() => setOpenParametreInterface(true)}
                          onMouseLeave={() => setOpenParametreInterface(false)}
                          className="annuaire__button"
                          onClick={() => {
                            props.handleMenu({
                              activeItemParametrage: 0,
                            });
                          }}
                        >
                          {location.pathname === "/parametrage" ? (
                            <img src={settingsBlanc} className="cog-annuaire" />
                          ) : (
                            <img src={settings} className="cog-annuaire" />
                          )}
                          {openParametreInterface && (
                            <div
                              className="annuaireInterface"
                              onMouseEnter={() =>
                                setOpenParametreInterface(true)
                              }
                              onMouseLeave={() =>
                                setOpenParametreInterface(false)
                              }
                            >
                              <MenuDepliant item="parametres" />
                            </div>
                          )}
                        </button>
                      </Link>
                    </li>
                  </>
                ) : (
                  <>
                    <li>
                      <Link
                        to="/groupes"
                        className={
                          useLocation().pathname == "/groupes"
                            ? "activeLink"
                            : ""
                        }
                        onMouseEnter={() => setOpenGroupeInterface(true)}
                        onMouseLeave={() => setOpenGroupeInterface(false)}
                      >
                        <button
                          className="annuaire__button"
                          onClick={() => {
                            props.handleMenu({
                              activeItemGroupes: 0,
                            });
                          }}
                        >
                          {findManagementContentByLabel(
                            "groupesTitle",
                            props.admin.editManagement,
                            props.admin.editManagementNexus,
                            props.auth.universityConnected.id
                          ).content || "Groupes"}
                          {openGroupeInterface && (
                            <div className="annuaireInterface">
                              <MenuDepliant item="groupe" />
                            </div>
                          )}
                        </button>
                      </Link>
                    </li>
                    {findItemInEditManagementVisibility(
                      "visibleAnnuaire",
                      props.admin.editManagementBoolean
                    ) && (
                      <li>
                        <Link
                          to="/annuaire"
                          className={
                            useLocation().pathname == "/annuaire"
                              ? "activeLink"
                              : ""
                          }
                          onMouseEnter={() => setOpenAnnuaireInterface(true)}
                          onMouseLeave={() => setOpenAnnuaireInterface(false)}
                        >
                          <button
                            className="annuaire__button"
                            onClick={() =>
                              props.handleMenu({
                                activeItemAnnuaire: itemsAnnuaireVisible[0],
                              })
                            }
                          >
                            {findManagementContentByLabel(
                              "annuaireTitle",
                              props.admin.editManagement,
                              props.admin.editManagementNexus,
                              props.auth.universityConnected.id
                            ).content || "Annuaire"}
                            {openAnnuaireInterface && (
                              <div className="annuaireInterface">
                                <MenuDepliant item="annuaire" />
                              </div>
                            )}
                          </button>
                        </Link>
                      </li>
                    )}
                  </>
                )}
              </>
            )}
          </ul>
        </div>
      </nav>
    </div>
  );
};

NavBar.propTypes = {
  navbarOpen: PropTypes.bool,
  handleToggle: PropTypes.func,
  auth: PropTypes.object,
  admin: PropTypes.object,
  handleAuth: PropTypes.func,
  handleMenu: PropTypes.func,
  items: PropTypes.object,
  annuaire: PropTypes.number,
  activeIndex: PropTypes.number,
  setActiveIndex: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
  admin: state.admin,
});

const mapDispatchToProps = (dispatch) => ({
  handleAuth: (value) => {
    dispatch(updateAuth(value));
  },
  handleMenu: (value) => {
    dispatch(updateMenu(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);
